import WorkaroundPage from './WorkaroundPage';

export default WorkaroundPage;
